import React from "react";
import { RecordAnyActions } from "./record-any-actions";
import { WebgeoRessourcesLabels } from "../../../../../config/shared/AccessManagerConfig";

interface RecordsTableProps {
    doAfterActionsClick?(): void;
    records: Record<string, string | number>[];
}

const HIDDEN_TEXT = "*************";

export const RecordsAnyTable: React.FC<RecordsTableProps> = ({
    doAfterActionsClick,
    records,
}) => {
    if (!records || records.length === 0) {
        return (
            <div className="text-gray-500 p-4">Nenhum registro encontrado.</div>
        );
    }

    // Gera dinamicamente os nomes das colunas, ignorando "geom_geojson"
    const columns = Object.keys(records[0]).filter(
        (col) => col !== "geom_geojson"
    );

    return (
        <div className="flex flex-col h-full w-full">
            <div className="overflow-x-auto overflow-y-auto sm:-mx-6 lg:-mx-4">
                <div className="inline-block min-w-full">
                    <div className="overflow-hidden">
                        <table className="min-w-full table-auto border-teal-900">
                            <thead className="border-b">
                                <tr className="bg-gray-100">
                                    <th className="text-lg font-bold text-gray-900 px-6 py-4 text-left">
                                        #
                                    </th>

                                    {columns.map((col) => {
                                        // Busca o nome legível no arquivo de config
                                        const readableName =
                                            WebgeoRessourcesLabels[col] || col;
                                        return (
                                            <th
                                                key={col}
                                                className="text-lg font-bold text-gray-900 px-6 py-4 text-left"
                                            >
                                                {readableName}
                                            </th>
                                        );
                                    })}
                                </tr>
                            </thead>
                            <tbody>
                                {records.map((record, index) => (
                                    <tr
                                        key={record.id || index}
                                        className={`${
                                            index % 2 !== 0
                                                ? "bg-gray-100 border-b"
                                                : "bg-white border-b"
                                        }`}
                                    >
                                        <td className="px-6 whitespace-nowrap text-sm font-medium text-gray-900">
                                            <div className="flex space-x-3.5">
                                                <RecordAnyActions
                                                    doAfterClick={
                                                        doAfterActionsClick
                                                    }
                                                    record={record}
                                                />
                                            </div>
                                        </td>

                                        {columns.map((col) => (
                                            <td
                                                key={col}
                                                className="text-sm text-gray-900 font-light px-6 py-4 whitespace-nowrap"
                                            >
                                                {record[col] !== undefined &&
                                                record[col] !== null
                                                    ? record[col]
                                                    : HIDDEN_TEXT}
                                            </td>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};
